export default {
    mainColor: '#9e0202',
}